import { ITEM_ICONS } from './iconManifest';

// Owner-drawn 80x80 item icons (client/public/icons/<id>.png; see oxide-vault/resources/icons.md).
// setItemVisual paints an element with the item's ICON when one exists, else the classic colour block --
// the manifest is generated from the actual files, so a missing icon never 404s, it just falls back.
export function itemIconUrl(id: string): string | null {
  return ITEM_ICONS.has(id) ? `/icons/${id}.png` : null;
}

// Apply icon-or-colour to a cell/swatch. `fallbackCss` is whatever background the element used before
// (tint gradient / flat hex). Icons sit on a faint dark plate so transparent PNGs read on any panel.
export function setItemVisual(el: HTMLElement, id: string, fallbackCss: string): boolean {
  const url = itemIconUrl(id);
  if (!url) { el.style.background = fallbackCss; return false; }
  el.style.background = `rgba(0,0,0,0.28) url('${url}') center / 88% no-repeat`;
  return true; // callers flip overlay text to light-on-dark (the colour blocks used dark text)
}
